import React from 'react'
import Highlighter from 'react-highlighter'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import AutocompleteResult from './AutocompleteResult'
import ProperCase from './helpers/properCase'
import { If, Text, LoadingWrapper } from 'src/Components'

import styles from './AutocompleteResults.module.scss'

const propTypes = {
  className: PropTypes.string,
  results: PropTypes.element,
  selected: PropTypes.bool,
  show: PropTypes.bool,
  onMouseEnter: PropTypes.bool,
  boldValue: PropTypes.bool,
  spin: PropTypes.bool,
  resultId: PropTypes.bool,
  onClick: PropTypes.func
}

const AutocompleteResults = ({
  className,
  results,
  selected,
  onClick,
  onMouseEnter,
  show,
  boldValue,
  spin,
  resultId,
  ...restProps
}) => {
  const hasResults = Boolean(results && results.length)

  if (!show) {
    return null
  }

  return (
    <ul
      className={classnames(styles.root, className)}
      role='listbox'
      data-qa='AutocompleteResults'
      {...restProps}
    >
      <LoadingWrapper done={!spin} innerElement='li' className={styles.spinner}>
        <If condition={hasResults}>
          {(results || []).map((r, i) => (
            <AutocompleteResult
              key={r.id}
              id={resultId(i)}
              onMouseEnter={() => onMouseEnter(i)}
              onClick={() => {
                onClick(i)
              }}
              focused={i === selected}
            >
              <Highlighter search={boldValue.trim()} matchElement={Text.Strong}>
                {ProperCase({ value: r.fullAddress })}
              </Highlighter>
            </AutocompleteResult>
          ))}
        </If>
        <If condition={!hasResults}>
          <li id={resultId(0)} className={styles.empty}>
            <FormattedMessage
              id='Autocomplete.empty'
              defaultMessage='No Results'
            />
          </li>
        </If>
      </LoadingWrapper>
    </ul>
  )
}

AutocompleteResults.propTypes = propTypes

export default AutocompleteResults
